import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import { HttpClient} from '@angular/common/http';
import {environment as env} from '../../../environments/environment';
import {LanguageService} from '../../services/language.service';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit {
  uname:string;
  sajid:string;
  orddata:[] = [];
  imgurl:String;
  isLoading:boolean;
  showLang:string;

  constructor(private router:Router, private route:ActivatedRoute,private langObj:LanguageService,
     private http:HttpClient) {
      this.langObj.langStr.subscribe((data)=>{
        this.showLang = data;
      });
    }

  ngOnInit(): void {
    this.isLoading = true;
    this.imgurl = env.imgurl;
    this.uname = localStorage.getItem('sajuname');
    this.sajid = localStorage.getItem('sajid');

    this.showLang = localStorage.getItem("showLang");
    if(this.showLang == null && this.showLang == undefined){
     this.showLang = 'en';
    }

    this.http.get(env.apiurl+'order-list/?userid='+this.sajid).subscribe(data=>{
      this.isLoading = false;
      this.orddata = data['data'];
    });

  }

}
